export const SALON_DASH_NAV = [
  { to: '/dashboard/salon', label: 'Overview', icon: 'fa fa-home' },
  { to: '/dashboard/salon/appointments', label: 'Appointments', icon: 'fa fa-calendar' },
  { to: '/dashboard/salon/earnings', label: 'Earnings', icon: 'fa fa-money' },
  { to: '/dashboard/salon/customers', label: 'Customers', icon: 'fa fa-users' },
  { to: '/dashboard/salon/services', label: 'Services', icon: 'fa fa-scissors' },
  { to: '/dashboard/salon/availability', label: 'Availability', icon: 'fa fa-clock-o' },
  { to: '/dashboard/salon/settings', label: 'Settings', icon: 'fa fa-cog' },
  { to: '/dashboard/salon/location', label: 'Location', icon: 'fa fa-map-marker' },
  { to: '/dashboard/salon/profile', label: 'Profile', icon: 'fa fa-user' },
];

export const GROOMER_DASH_NAV = [
  { to: '/dashboard/groomer', label: 'Overview', icon: 'fa fa-home' },
  { to: '/dashboard/groomer/appointments', label: 'Appointments', icon: 'fa fa-calendar' },
  { to: '/dashboard/groomer/earnings', label: 'Earnings', icon: 'fa fa-money' },
  { to: '/dashboard/groomer/availability', label: 'Availability', icon: 'fa fa-clock-o' },
  { to: '/dashboard/groomer/settings', label: 'Settings', icon: 'fa fa-cog' },
  { to: '/dashboard/groomer/location', label: 'Location', icon: 'fa fa-map-marker' },
  { to: '/dashboard/groomer/profile', label: 'Profile', icon: 'fa fa-user' },
];
